import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api/gameApi'
import {
  buyItemShopSuccess,
  buyItemShopFailed,
  BUY_ITEM_SHOP_START,
} from '../../actions/shop'

/**
 * Buy item Shop api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const buyItemShopApi = (props) => {
  const uri = `/api/item/sale-training-item`;
  return api.post(uri, props, {
    headers: {
      authorization: `Bearer ${localStorage.getItem('auth_token')}`,
    },
  });
};

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doBuyItemShop(action) {
  try {
    const response = yield call(buyItemShopApi, action?.payload)
    yield put(buyItemShopSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(buyItemShopFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch Sign Buy Shop
 */
export default function* watchBuyItemShop() {
  yield takeLatest(BUY_ITEM_SHOP_START, doBuyItemShop)
}
